/**
 * Fonte única — app (utils/storePresence) + CF (sync no build das functions).
 * Heartbeat vendor = 120s → 8 min = 4 batidas de margem.
 */
export const PRESENCE_TTL_MS = 8 * 60 * 1000;
